import { useEffect, useState } from "react";
import { Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import LanguageSwitcher from "../LanguageSwitcher";
import {
  HeaderSection,
  HeaderNav,
  LogoContainer,
  NavList,
  NavItem,
  ContactLink,
  Burger,
  MobileRight,
  DrawerHead,
  DrawerNav,
  CloseButton,
} from "./styles";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setVisibility(false);
  };

  const links = [
    { id: "services", label: t("Servicios") },
    { id: "iva", label: t("Recuperación IVA") },
  ];

  return (
    <HeaderSection $scrolled={scrolled}>
      <Container>
        <HeaderNav>
          <LogoContainer to="/" aria-label="Grupo Contable Cantos — Inicio">
            <img src="/img/svg/logo.png" alt="Cantos Contabilidad" width="138" height="42" />
          </LogoContainer>

          <NavList aria-label={t("Navegación principal")}>
            {links.map((l) => (
              <NavItem key={l.id} type="button" onClick={() => scrollTo(l.id)}>
                {l.label}
              </NavItem>
            ))}
            <LanguageSwitcher />
            <ContactLink type="button" onClick={() => scrollTo("contact")}>
              {t("Contact")}
            </ContactLink>
          </NavList>

          <MobileRight>
            <LanguageSwitcher />
            <Burger
              type="button"
              onClick={() => setVisibility(true)}
              aria-label={t("Abrir menú")}
              aria-expanded={visible}
            >
              <span />
              <span />
            </Burger>
          </MobileRight>
        </HeaderNav>

        <Drawer
          closable={false}
          open={visible}
          onClose={() => setVisibility(false)}
          placement="right"
        >
          <DrawerHead>
            <img src="/img/svg/logo.png" alt="Cantos Contabilidad" width="112" height="34" />
            <CloseButton
              type="button"
              onClick={() => setVisibility(false)}
              aria-label={t("Cerrar menú")}
            >
              ×
            </CloseButton>
          </DrawerHead>
          <DrawerNav>
            {links.map((l) => (
              <NavItem key={l.id} type="button" onClick={() => scrollTo(l.id)}>
                {l.label}
              </NavItem>
            ))}
            <ContactLink type="button" onClick={() => scrollTo("contact")}>
              {t("Contact")}
            </ContactLink>
          </DrawerNav>
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
